import AbstractShape from '../../../source/js/shared/models/Geometry/AbstractShape';

export class PriceCalculator {
	private price_per_square_meter: number;
	private minimum_price: number;
	private circumference_price_per_meter: number;

	constructor( price_per_square_meter: number, minimum_price: number, circumference_price_per_meter: number ) {
		this.price_per_square_meter = price_per_square_meter;
		this.minimum_price = minimum_price;
		this.circumference_price_per_meter = circumference_price_per_meter;
	}

	calculate_material_price( shape: AbstractShape ): number {
		const required_material = shape.get_required_material();
		const price = this.price_per_square_meter * required_material.get_area().in_m2();
		return price;
	}

	calculate_sawing_price( shape: AbstractShape ): number {
		return this.circumference_price_per_meter * shape.get_circumference().in_m();
	}

	calculate( shape: AbstractShape ): number {
		let price = this.calculate_material_price( shape );
		price += this.calculate_sawing_price( shape );

		if ( price < this.minimum_price ) {
			price = this.minimum_price;
		}

		return price;
	}
}
